import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=8f80614c&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=8f80614c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f80614c",
  null
  
)

export default component.exports